export const INITIAL_BASE_WIDTH = 160;
export const SIGNATURE_BOX_MIN_WIDTH = 80;
export const SIGNATURE_BOX_RATIO: [number, number] = [16, 9];
export const SIGNATURE_INFO_MIN_WIDTH_PERCENTAGE = 0.2;
export const SIGNATURE_INFO_FONT_SIZE_PERCENTAGE = 0.017;
export const ASPECT_RATIO = SIGNATURE_BOX_RATIO[1] / SIGNATURE_BOX_RATIO[0]; // 16:9 aspect ratio
export const SIGNATURE_INFO_TEXT_MARGIN_PERCENTAGE = SIGNATURE_INFO_FONT_SIZE_PERCENTAGE / 2;
export const SIGNATURE_BOX_MIN_HEIGHT = SIGNATURE_BOX_MIN_WIDTH / SIGNATURE_BOX_RATIO[0] * SIGNATURE_BOX_RATIO[1];
